/**
 * supply system stub — v0M2.3 placeholder.
 *
 * Draw supply from network (cities / depots / roads); apply
 * attrition to unsupplied Armies per ECONOMY.md §6.
 *
 * v0M2.3 stub returns state unchanged. Real implementation lands
 * per the consuming milestone.
 */

import type { Command } from './commands';
import type { GameState } from './state';
import type { RngState } from './rng';
import type { SimContext } from './sim-context';

export function supplySystem(
  state: GameState,
  _commands: readonly Command[],
  _rng: RngState,
  _context: SimContext,
): GameState {
  return state;
}
